import { Instagram } from "lucide-react";

export const IG_HANDLE = "ifweknew_audio";
export const TIKTOK_HANDLE = "if.we.knew";
export const IG_URL = "https://instagram.com/" + IG_HANDLE;
export const TIKTOK_URL = "https://www.tiktok.com/@" + TIKTOK_HANDLE;

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.5 20.1a6.34 6.34 0 0 0 10.86-4.43V8.78a8.16 8.16 0 0 0 4.77 1.52V6.86a4.85 4.85 0 0 1-1.54-.17Z"/>
  </svg>
);

export default function SocialLinks({ variant = "row", showLabels = false, size = "md" }) {
  const sz = size === "sm" ? 14 : size === "lg" ? 22 : 16;
  const btn = "flex items-center gap-2 border border-white/20 hover:border-hotpink hover:text-hotpink text-white/80 transition-colors font-outfit uppercase tracking-widest";
  const pad = size === "sm" ? "px-2 py-1.5 text-[10px]" : size === "lg" ? "px-5 py-3 text-xs" : "px-3 py-2 text-[10px]";
  return (
    <div className={"flex items-center " + (variant === "stack" ? "flex-col gap-2" : "gap-3 flex-wrap")} data-testid="social-links">
      <a href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className={btn + " " + pad} aria-label={"Instagram @" + IG_HANDLE}>
        <Instagram size={sz} />
        <span>@{IG_HANDLE}</span>
      </a>
      <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" data-testid="social-tiktok" className={btn + " " + pad} aria-label={"TikTok @" + TIKTOK_HANDLE}>
        <TikTokIcon size={sz} />
        <span>@{TIKTOK_HANDLE}</span>
      </a>
    </div>
  );
}
